module.exports = __webpack_public_path__ + "img/logo_top.53eaf929.png";